export const mutationsType={
    SHOW_LOADING:'SHOW_LOADING',
    HIDE_LOADING:'HIDE_LOADING',
    INIT_ACCOUNT_INFO:'INIT_ACCOUNT_INFO',
    SET_ACCOUNT_INFO:'SET_ACCOUNT_INFO',
    SET_LOGIN_PRE_PATH:'SET_LOGIN_PRE_PATH'  
}